import { useQuery } from '@tanstack/react-query';
import { revenueApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business revenue__daily（売上/前受金の2ブロック12指標）を期間指定で取得するフック。旧Hub（v0）の表/チャート/CSV用で、v0 を見ていないときは取得しない。
 * @graph-connects revenueApi [calls] revenue__daily API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useRevenueRecords(
  from: string | undefined,
  to: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: queryKeys.revenue.records(from, to),
    queryFn: () => revenueApi.getRecords({ from, to }),
    staleTime: 5 * 60_000,
    retry: false,
    enabled,
  });
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business revenue__validation_log（検算結果履歴）を取得するフック。旧Hub（v0）の要対応タブの合格/警告/不合格サマリと履歴一覧に使い、v0 を見ていないときは取得しない。
 * @graph-connects revenueApi [calls] revenue__daily API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useValidationLogs(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.revenue.validationLogs,
    queryFn: () => revenueApi.getValidationLogs(),
    staleTime: 5 * 60_000,
    retry: false,
    enabled,
  });
}
